<template>
  <header class="page-header" :class="{ 'page-header--eudora': brand === 'eudora' }">
    <div class="brand-strip">
      <div class="brand-strip__segment" style="background-color: #31a473"></div>
      <div class="brand-strip__segment" style="background-color: #d345af"></div>
      <div class="brand-strip__segment" style="background-color: #8e2330"></div>
      <div class="brand-strip__segment" style="background-color: #613a53"></div>
    </div>

    <div class="page-header__top">
      <div class="header-logo">
        <img src="/img/logo.png" alt="Logo" style="width: 120px" />
      </div>

      <div
        v-if="userName"
        class="page-header__user"
        :class="{ 'page-header__user--open': userMenuOpen }"
        ref="userMenuRoot"
      >
        <button
          type="button"
          class="page-header__user-trigger"
          :aria-expanded="userMenuOpen ? 'true' : 'false'"
          aria-haspopup="true"
          @click.stop="toggleUserMenu"
        >
          <span class="page-header__user-name">{{ displayNameUpper }}</span>
          <i class="fa fa-chevron-down page-header__user-chevron" aria-hidden="true" />
        </button>
        <div
          v-show="userMenuOpen"
          class="page-header__dropdown"
          role="menu"
          @click.stop
        >
          <button type="button" class="page-header__dropdown-item" role="menuitem" @click="onEncerrar">
            <span>Encerrar</span>
            <i class="fa fa-sign-out page-header__dropdown-icon" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>

    <hr class="header-divider" />

    <div class="step-indicator" v-if="currentStep > 0 && showSteps">

      <div
        v-for="step in steps"
        :key="step.id"
        class="step-item"
      >
        <div
          class="step-circle"
          :class="{
            'step-circle--done':   currentStep > step.id,
            'step-circle--active': currentStep === step.id,
            'step-circle--future': currentStep < step.id,
          }"
        >
          <span>{{ step.id }}</span>
        </div>
        <span
          class="step-label"
          :class="{ 'step-label--future': currentStep < step.id }"
        >{{ step.label }}</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    currentStep: { type: Number, default: 1 },
    brand: { type: String, default: 'default' },
    showSteps: { type: Boolean, default: true },
    userName: { type: String, default: '' },
    logoutFrom: { type: String, default: 'Boticario' },
  },
  data() {
    return {
      userMenuOpen: false,
      steps: [
        { id: 1, label: 'Pendências' },
        { id: 2, label: 'Ofertas' },
        { id: 3, label: 'Pagamento' },
        { id: 4, label: 'Resumo' },
      ],
    };
  },
  computed: {
    displayNameUpper() {
      return String(this.userName || '').toUpperCase();
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick);
  },
  methods: {
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen;
    },
    closeUserMenu() {
      this.userMenuOpen = false;
    },
    onDocClick(e) {
      if (!this.userMenuOpen) return;
      const root = this.$refs.userMenuRoot;
      if (root && root.contains(e.target)) return;
      this.closeUserMenu();
    },
    onEncerrar() {
      this.closeUserMenu();
      this.$emit('logout', this.logoutFrom);
    },
  },
};
</script>

<style scoped>
.page-header {
  background: #fff;
  padding-bottom: 12px;
}

.brand-strip {
  display: flex;
  height: 16px;
  width: 100%;
}
.brand-strip__segment {
  flex: 1;
}

.page-header__top {
  position: relative;
  padding: 20px 16px 4px;
}

.header-logo {
  text-align: center;
}

.page-header__user {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 20;
}

.page-header__user-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 6px 4px;
  font-family: 'Inter', sans-serif;
  font-size: 0.92rem;
  font-weight: 600;
  color: #333438;
  letter-spacing: 0.02em;
}

.page-header__user-name {
  text-transform: uppercase;
}

.page-header__user-chevron {
  font-size: 0.65rem;
  color: #555;
  font-weight: 400;
}

.page-header__dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 240px;
  max-width: calc(100vw - 32px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.14);
  padding: 10px 12px;
  box-sizing: border-box;
}

.page-header__dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 10px 8px;
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 500;
  color: #333438;
  text-align: left;
  border-radius: 8px;
}

.page-header__dropdown-item:hover {
  background: #f5f5f5;
}

.page-header__dropdown-icon {
  font-size: 1.1rem;
  color: #555;
}

@media (min-width: 992px) {
  .page-header__top {
    padding: 20px 24px 8px;
    min-height: 72px;
  }

  .page-header__user {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0;
    align-items: flex-end;
  }

  .page-header__dropdown {
    left: auto;
    right: 0;
    transform: none;
  }
}

.header-divider {
  margin: 12px 0 16px;
  border-color: #e6e7e9;
}

.step-indicator {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 0;
  min-width: 0;
}

@media (min-width: 768px) {
  .step-indicator {
    max-width: var(--negotiation-layout-max-width, 960px);
    padding: 0 24px;
  }
}

.step-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 0.85rem;
  transition: all 0.25s;
  flex-shrink: 0;
}

.step-circle--done {
  background: #43464b;
  color: #fff;
  border: 2px solid #43464b;
}
.step-circle--active {
  background: #fff;
  color: #43464b;
  border: 2px solid #43464b;
  font-weight: 900;
}
.step-circle--future {
  background: #f5f5f5;
  color: #43464b;
  border: 2px solid #f5f5f5;
}

.step-label {
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 500;
  color: #43464b;
  margin-top: 6px;
  text-align: center;
  white-space: nowrap;
}
.step-label--future {
  color: #43464b;
}

.page-header--eudora .step-circle--active {
  border-color: #613a53;
  color: #613a53;
}

@media (max-width: 480px) {
  .brand-strip {
    height: 12px;
  }
  .step-label {
    font-size: 0.6rem;
  }
  .step-circle {
    width: 30px;
    height: 30px;
    font-size: 0.75rem;
  }
}
</style>
